import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { pick } from 'lodash';

export class CommaList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: props.startExpanded,
    };
  }

  toggleShrink(e, newState = !this.state.expanded) {
    e.preventDefault();
    this.setState({ expanded: newState });
  }

  render() {
    const { state, props } = this;
    const { expanded } = state;

    if (!props.list || !Array.isArray(props.list)) return null;

    return (
      <div {...pick(props, ['className', 'style'])}>
        <ul
          className={classNames('comma-list', { shrink: !expanded })}
          ref={(ul) => (this.list = ul)}
        >
          {props.list.map((node, index) => (
            <li key={node + index}>{node}</li>
          ))}
        </ul>

        {state.canBeExpanded && (
          <div className="comma-list-controls">
            {!expanded && (
              <a href="#" onClick={(e) => this.toggleShrink(e)}>
                more
              </a>
            )}

            {expanded && !props.noShrink && (
              <a href="#" onClick={(e) => this.toggleShrink(e)}>
                less
              </a>
            )}
          </div>
        )}
      </div>
    );
  }

  componentDidMount() {
    const { list } = this;
    if (list.offsetWidth < list.scrollWidth) {
      this.setState({ canBeExpanded: true });
    }
  }
}

CommaList.defaultProps = {
  startExpanded: false,
  noShrink: false,
  list: PropTypes.arrayOf(PropTypes.node.isRequired),
};

export default CommaList;
